//eslint-disable-next-line
import axios, { $asyncGet, $asyncPost } from "./common.js";
/* import store from "../../store/index";
import { testR } from "../common"; */

/**
 *  创建威富通商户号
 * v3/swiftpass/configure/generate
 */
export const swiftConfigure = function (datas) {
  var data = {
    ...datas
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("v3/swiftpass/configure/generate", JSON.stringify(data));
};

/**
 * 获取威富通信息
 *
 */
export const swiftQuery = function (mch_no, pass_word) {
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  var data = {
    pass_word
  };
  return axios.post(
    "v3/swiftpass/configure/query?mch_no=" + mch_no,
    JSON.stringify(data)
  );
};
/**
 * 修改
 */
export const swiftModify = function (datas) {
  var data = {
    ...datas
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("v3/swiftpass/configure/modify", JSON.stringify(data));
};

/**
 * 获取所有威富通商户
 * swiftpass/v2/configure/list
 */
export const swiftGetList = function () {
  /* axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  }; */
  return new Promise((resolve, reject) => {
    axios.get("v3/swiftpass/configure/list").then(res => {
      if (res.data && res.data.resp_data && res.data.resp_data.state === "OK") {
        resolve(res.data.resp_data.items);
      }
    });
  });
};

/**
 * 随行付进件
 * @param {string} merchant_id 店铺id
 */
//v3/suixing/apply/apply
export const swiftApply = function (merchant_id) {
  return $asyncPost(`v3/suixing/apply/apply?service_no=${localStorage.getItem("service_no")}&merchant_id=${merchant_id}`);
}

/**
 * 随行付进件列表
 * @returns
 */
export const swiftApplyList = function () {
  return $asyncGet(`v3/suixing/apply/list?service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 进件状态
 * /v3/suixing/apply/query
 */
export const swiftQueryApply = function (applyment_id) {
  return $asyncGet(`v3/suixing/apply/query?applyment_id=${applyment_id}&service_no=${localStorage.getItem("service_no")}`);
}
/**
 * 微信实名认证结果查询
 * /v3/suixing/apply/QueryWechatApply
 */
export const swiftQueryWechatApply = function (mch_no) {
  return $asyncGet(`v3/suixing/apply/QueryWechatApply?mch_no=${mch_no}`);
}
/**
 * 支付宝实名认证结果查询
 * /v3/suixing/apply/queryAliApply
 */
export const swiftQueryAliApply = function (mch_no) {
  return $asyncGet(`v3/suixing/apply/queryAliApply?mch_no=${mch_no}`);
}
/**
 * 提交微信实名认证 post
 * /v3/suixing/apply/SubmitWechatApply
 */
export const swiftSubmitWechatApply = function (mch_no) {
  return $asyncPost(`v3/suixing/apply/SubmitWechatApply?mch_no=${"399260109360329"}&service_no=${localStorage.getItem("service_no")}`);
}
/**
 * 提交支付宝实名认证 post
 * /v3/suixing/apply/SubmitAliApply
 */
export const swiftSubmitAliApply = function (mch_no) {
  return $asyncPost(`v3/suixing/apply/SubmitAliApply?mch_no=${"399260109360329"}&service_no=${localStorage.getItem("service_no")}`);
}